var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"form"},[(_vm.error !== undefined && _vm.error.length > 0)?_c('div',{staticClass:"alert--error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("LOADING")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415aa84e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ActivationPage.vue
// module id = 1127
// module chunks = 5